import getDisplayName from './getDisplayName';

const getWrappedDisplayName = (WrappedComponent, wrapDisplayName) =>
  `${wrapDisplayName}(${getDisplayName(WrappedComponent)})`;

export default getWrappedDisplayName;
